import { render } from "./MaterialItem.vue?vue&type=template&id=26dbef94&lang=pug"
import script from "./MaterialItem.vue?vue&type=script&lang=js"
export * from "./MaterialItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__